module.exports = __webpack_public_path__ + "static/full-744a3b5c62bdadba9584de5cfb2a73ba.pdf";